import React, { useEffect, useState } from 'react';
import { Box, HStack, Text, Input, Button, Select } from '@chakra-ui/react';
import { MainteTrainsType } from '../Table/MaintenanceTrainsTable';
import { QueryTrainsApi } from '../../../../apis/QueryMaintenance.api';
import { TrainGroupsNameType } from '../../../../apis/ApiClient';
import { TrainsSearchCondition } from '../../../../pages/TrainsMaintenance';
import { MaintenanceCompareEnum } from '../../../constants/MaintenanceConstants';

interface props {
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<MainteTrainsType[] | undefined>
  >;
  TrainGroupsDatas: TrainGroupsNameType[] | undefined;
  Query: TrainsSearchCondition;
  setQuery: React.Dispatch<React.SetStateAction<TrainsSearchCondition>>;
  createOrUpdate: boolean;
  SearchStateSwitch: () => void;
}

const TrainsSearchBox: React.FC<props> = (props) => {
  const {
    setMaintenanceDatas,
    TrainGroupsDatas,
    Query,
    setQuery,
    createOrUpdate,
    SearchStateSwitch
  } = props;
  const [selectCompare, setSelectCompare] = useState(
    MaintenanceCompareEnum.Equal
  );
  const [trainNumber, setTrainNumber] = useState('');
  const [model, setModel] = useState('');
  const [dateCreatedFrom, setDateCreatedFrom] = useState('');
  const [dateCreatedTo, setDateCreatedTo] = useState('');
  const [dateUpdatedFrom, setDateUpdatedFrom] = useState('');
  const [dateUpdatedTo, setDateUpdatedTo] = useState('');

  useEffect(() => {
    setSelectCompare(MaintenanceCompareEnum.Equal);
    setTrainNumber('');
    setModel('');
    setDateCreatedFrom('');
    setDateCreatedTo('');
    setDateUpdatedFrom('');
    setDateUpdatedTo('');
  }, [createOrUpdate]);

  const SerachGetApi = async () => {
    const params = new URLSearchParams();

    if (trainNumber !== '') {
      switch (selectCompare) {
        case MaintenanceCompareEnum.Equal:
          params.append('no_eq', trainNumber);
          break;
        case MaintenanceCompareEnum.Greater:
          params.append('no_gt', trainNumber);
          break;
        case MaintenanceCompareEnum.Less:
          params.append('no_lt', trainNumber);
          break;
      }
    }
    Query.sort.key !== '' &&
      params.append(
        'order',
        Query.sort.key + (Query.sort.sortType ? '_asc' : '_desc')
      );
    model !== '' && params.append('train_group_id_eq', model);
    dateCreatedFrom !== '' && params.append('created_at_gte', dateCreatedFrom);
    dateCreatedTo !== '' && params.append('created_at_lt', dateCreatedTo);
    dateUpdatedFrom !== '' && params.append('updated_at_gte', dateUpdatedFrom);
    dateUpdatedTo !== '' && params.append('updated_at_lt', dateUpdatedTo);
    const apiQuery = '/?' + params.toString();

    setQuery((pre) => ({
      ...pre,
      trainNumber: { compare: selectCompare, number: trainNumber },
      model: model,
      dateCreatedFrom: dateCreatedFrom,
      dateCreatedTo: dateCreatedTo,
      dateUpdatedFrom: dateUpdatedFrom,
      dateUpdatedTo: dateUpdatedTo
    }));

    const response = await QueryTrainsApi(apiQuery);
    if (response.success) {
      setMaintenanceDatas(response.data as MainteTrainsType[]);
      SearchStateSwitch();
    }
  };
  return (
    <>
      <Box
        border='1px'
        borderColor='gray'
        ml={14}
        gridRow='2/3'
        gridColumn='2/2'
        w='80%'
        h='320px'
        bgColor='#f4f4f4'
        fontSize={14}
      >
        <Box fontSize={18} bgColor='#e5e6e7'>
          <Text>検索条件</Text>
        </Box>
        <Box w='90%'>
          <Text ml={2} mt={1}>
            車号
          </Text>
          <HStack>
            <Select
              h='8'
              ml={2}
              value={selectCompare}
              onChange={(e) => setSelectCompare(e.target.value)}
            >
              <option value={MaintenanceCompareEnum.Equal}>等しい</option>
              <option value={MaintenanceCompareEnum.Greater}>より大きい</option>
              <option value={MaintenanceCompareEnum.Less}>より小さい</option>
            </Select>
            <Input
              h='8'
              ml={2}
              bgColor='white'
              value={trainNumber}
              onChange={(e) => setTrainNumber(e.target.value)}
            ></Input>
          </HStack>
          <Text ml={2} mt={1}>
            形式
          </Text>
          <Select
            h='8'
            ml={2}
            bgColor='white'
            value={model}
            onChange={(e) => setModel(e.target.value)}
          >
            <option value={''}>任意</option>
            {TrainGroupsDatas?.map((data, i) => {
              return (
                <option key={'option' + i} value={data.id}>
                  {data.type}
                </option>
              );
            })}
          </Select>
          <Text ml={2} mt={1}>
            登録日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedFrom}
              onChange={(e) => setDateCreatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedTo}
              onChange={(e) => setDateCreatedTo(e.target.value)}
            />
          </HStack>
          <Text ml={2} mt={1}>
            更新日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedFrom}
              onChange={(e) => setDateUpdatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedTo}
              onChange={(e) => setDateUpdatedTo(e.target.value)}
            />
          </HStack>
          <Button
            ml={2}
            mt={2}
            bgColor='gray.800'
            color='white'
            onClick={() => SerachGetApi()}
          >
            絞り込む
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default React.memo(TrainsSearchBox);
